import { useState } from 'react';
import Select, { SingleValue } from 'react-select';
import { useNavigate } from 'react-router-dom';
import { useSearchResturantLazyQuery } from '../../utils/__generated__/graphql';

const SearchDropdown = ({ handleChange }: { handleChange?: (newValue: string) => void }) => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [search, { loading, data }] = useSearchResturantLazyQuery({
    variables: { searchTerm },
  });

  const options =
    data?.restaurant.map((result) => ({
      value: result.id,
      label: result.name,
    })) || [];

  const handleInputChange = (newValue: string) => {
    setSearchTerm(newValue);
    search({ variables: { searchTerm: newValue } });
  };

  const handleClick = (
    opt: SingleValue<{
      value: any;
      label: string;
    }>
  ) => {
    handleChange ? handleChange(opt?.value) : navigate(`/admin/edit-restaurant/${opt?.value}`);
  };

  return (
    <Select
      options={options}
      isLoading={loading}
      isClearable
      isSearchable
      onInputChange={handleInputChange}
      onChange={handleClick}
      placeholder="Search restaurants..."
      styles={{
        container: (base) => ({
          ...base,
          width: '300px',
        }),
        control: (base) => ({
          ...base,
          minHeight: '40px',
          borderColor: '#E2E8F0',
          boxShadow: 'none',
          '&:hover': {
            borderColor: '#CBD5E0',
          },
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        }),
      }}
    />
  );
};

export default SearchDropdown;
